<template>
  <div class="black_box dis_f fle_t">
    <div class="top_box dis_f fle_t">
      <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img src="@/assets/img/audio_close.png" @click="openBg" v-else class="contro_audio right" alt>
      <audio ref="audioDom" :src="currentSrc" class="dis_n"></audio>
      <div class="test_list dis_f ali_top fle_no" @click="tagChange(0)">
        <div class="list_tag" :class="{'active':testData[1]==0}">
          <img src="@/assets/img/list_tag_a.png" alt>
        </div>
        <div class="list_audio dis_f ali_ct jus_bt">
          <span>20"</span>
          <img src="@/assets/img/audio_icon.png" alt>
        </div>
      </div>
      <div class="test_list dis_f ali_top ml70 fle_no" @click="tagChange(1)">
        <div class="list_tag" :class="{'active':testData[1]==1}">
          <img src="@/assets/img/list_tag_b.png" alt>
        </div>
        <div class="list_audio dis_f ali_ct jus_bt">
          <span>22"</span>
          <img src="@/assets/img/audio_icon.png" alt>
        </div>
      </div>
      <div class="test_list dis_f ali_top ml140 fle_no" @click="tagChange(2)">
        <div class="list_tag" :class="{'active':testData[1]==2}">
          <img src="@/assets/img/list_tag_c.png" alt>
        </div>
        <div class="list_audio dis_f ali_ct jus_bt">
          <span>18"</span>
          <img src="@/assets/img/audio_icon.png" alt>
        </div>
      </div>
      <img src="@/assets/img/two_txt.png" class="two_txt fle_no" alt>
      <div class="fl1"></div>
      <img
        src="@/assets/img/next_btn.png"
        data-name="2下一题"
        @click="openPage"
        class="test_btn fle_no"
        alt
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      audioArr: [
        require("@/assets/audio/audio_A.mp3"),
        require("@/assets/audio/audio_B.mp3"),
        require("@/assets/audio/audio_C.mp3")
      ], //音乐数组
      currentSrc: "", //音乐路径
      audioType: false
    };
  },
  computed: {
    ...mapState(["testData"])
  },
  mounted() {
    const that = this;
    this.$refs.audioDom.addEventListener("play", function() {
      that.$store.commit("setAudioPlay", false);
      that.audioType = true;
    });
    this.$refs.audioDom.addEventListener("ended", function() {
      that.$store.commit("setAudioPlay", true);
      that.audioType = false;
    });
    this.$refs.audioDom.addEventListener("pause", function() {
      that.$store.commit("setAudioPlay", true);
      that.audioType = false;
    });
  },
  methods: {
    tagChange(num) {
      this.currentSrc = this.audioArr[num];
      this.$nextTick(() => {
        this.$refs.audioDom.play();
      });
      const data = JSON.parse(JSON.stringify(this.testData));
      data[1] = num;
      this.$store.commit("setStoreData", {
        name: "testData",
        data: data
      });
    },
    openPage() {
      if (typeof this.testData[1] == "undefined") {
        this.$toast("请选择选项");
        return;
      }
      this.$router.replace("three");
    },
    openBg() {
      if (!this.audioType) {
        this.$store.commit("setAudioPlay", true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top_box {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  background: url("~@/assets/img/two_bg.png") no-repeat center top;
  background-size: contain;
  padding-top: 450px;
}

.test_list {
  padding: 0 30px;
  flex-shrink: 0;
  margin-bottom: 55px;
  &.ml70 {
    margin-left: 70px;
  }
  &.ml140 {
    margin-left: 140px;
  }
  .list_tag {
    flex-shrink: 0;
    margin-right: 20px;
    position: relative;
    &.active::before {
      content: "";
      position: absolute;
      left: 6px;
      top: 80px;
      transform: translateX(-25%);
      width: 114px;
      height: 32px;
      background: url("~@/assets/img/test_checked.png") no-repeat center;
      background-size: cover;
    }
    img {
      width: 74px;
    }
  }
  .list_audio {
    width: 398px;
    height: 80px;
    background-color: #ffffff;
    border-radius: 10px;
    border: solid 5px #f00000;
    border-radius: 8px;
    padding-left: 40px;
    padding-right: 30px;
    span {
      color: rgba(13, 0, 0, 1);
      font-size: 40px;
      color: rgba(13, 0, 0, 1);
    }
    img {
      height: 60px;
    }
  }
}
.two_txt {
  width: 690px;
  margin: 50px auto;
}
</style>
